/**
 * Copyright © 2026 Adnuntius AS.
 */
import {DOCUMENT, Component, Inject, OnInit} from '@angular/core';

import {ApiConfig} from '../config/api-config';
import template from './welcome-page.component.html';
import {AppSharedModule} from '../common/app-shared.module';

@Component({
  standalone: true,
  imports: [AppSharedModule],
  selector: 'adn-welcome-page',
  template
})
export class WelcomePageComponent implements OnInit {
  readonly showMailingList = this.apiConfig.getEnv() !== 'localhost';

  constructor(
    @Inject(DOCUMENT) private readonly document: any,
    private readonly apiConfig: ApiConfig
  ) {
  }

  ngOnInit(): void {
    if (!this.showMailingList) {
      return;
    }
    const scriptId = 'hs-forms-embed';
    if (!this.document.getElementById(scriptId)) {
      const script = this.document.createElement('script');
      script.id = scriptId;
      script.src = 'https://js-eu1.hsforms.net/forms/embed/147239819.js';
      this.document.body.appendChild(script);
    }
  }
}
